import { Dictionary } from "lodash";

import { DraftShippingPlanItem } from "inbounds/InboundTypes";
import { RootState } from "RootReducer";

export const selectPlanItems = (state: RootState): Dictionary<DraftShippingPlanItem> => state.inbound.planItems.byId;
